import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { ClientsPath } from 'entities/ExportRouters'
import { CreateProvider } from 'pages/clients/pages/create/context/createContext'
import styles from './styles.module.scss'

export const CreateLayout = observer(() => {
  return (
    <CreateProvider>
      <div className={styles.wrapper}>
        <div className={styles.closeIconWrapper}>
          <IconButton
            ariaLabel='close_create_client'
            icon='close'
            size='medium'
            variant='icon'
            color='tertiary'
            onClick={() => uiStore.changeRoute({ path: ClientsPath.root })}
          />
        </div>
        <div className={styles.container}>
          <div className={styles.content}>{<Outlet />}</div>
        </div>
      </div>
    </CreateProvider>
  )
})
